import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "回答待ち", enum: "ANSWER_WAIT" },
  { value: 2, text: "承認待ち", enum: "APPROVAL_WAIT" },
  { value: 3, text: "出荷待ち", enum: "SHIPPING_WAIT" },
  { value: 4, text: "出荷済み", enum: "SHIPED" },
  { value: 5, text: "キャンセル", enum: "CANCELED" },
]);
